import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

import { useAdminRedeemable } from '@repo/common/queries/admin/redeem'

import { RedeemableDetail } from '@/components/Redeem/RedeemableDetail'
import { RedemptionsTable } from '@/components/Redeem/RedemptionsTable'
import { UnderlyingRedemptionsTable } from '@/components/Redeem/UnderlyingRedemptionsTable'
import { useDynamicTitle, withTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/$id/')({
  component: RedeemableDetailPage,
  head: withTitle((params) => `Redeemable ${params.id!}`),
})

function RedeemableDetailPage() {
  const { id } = Route.useParams()
  const { data: redeemable } = useAdminRedeemable(id!)

  useDynamicTitle(
    redeemable?.name ? `Redeemable: ${redeemable.name}` : undefined,
  )

  return (
    <Stack>
      <RedeemableDetail redeemable={redeemable} />
      {redeemable && (
        <>
          <UnderlyingRedemptionsTable
            underlyingRedemptions={redeemable.underlying_redemptions.nodes}
            totalCount={redeemable.underlying_redemptions.total_count}
            slim
            redeemableId={redeemable.id}
          />
          <RedemptionsTable
            redeemableName={redeemable.name}
            redeemableId={redeemable.id}
          />
        </>
      )}
    </Stack>
  )
}
